class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.querySelector('cart-drawer');
    this.header = document.querySelector('sticky-header');
    this.sections = ['mini-cart', 'cart-icon-bubble'];
    this.isUpdating = false;

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    this.bindEvents();
    this.bindGlobalAddToCart();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.updateCart();
  }

  bindEvents() {
    this.addEventListener('click', (event) => {
      if (this.isUpdating) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      const quantityButton = event.target.closest('.quantity__button');
      const removeButton = event.target.closest('cart-remove-button a');

      if (quantityButton) {
        event.preventDefault();
        event.stopPropagation();
        this.handleQuantityChange(quantityButton);
      } else if (removeButton) {
        event.preventDefault();
        event.stopPropagation();
        this.handleRemove(removeButton);
      }
    });

    this.addEventListener('change', (event) => {
      if (this.isUpdating) return;
      if (event.target.classList.contains('quantity__input')) {
        this.handleInputChange(event.target);
      }
    });
  }

  bindGlobalAddToCart() {
    document.addEventListener('click', async (event) => {
      const addBtn = event.target.closest('add-to-cart');
      if (!addBtn) return;

      const variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      event.preventDefault();
      event.stopPropagation();

      await this.handleAddToCart(addBtn, variantId);
    });
  }

  async handleAddToCart(button, variantId) {
  const originalContent = button.innerHTML;
  button.innerHTML = 'Adding...';
  button.style.pointerEvents = 'none';
  button.style.opacity = '0.7';

  try {
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await cartResponse.json();
    
    const existingItem = cart.items.find(item => item.variant_id == variantId);

    let response;
    if (existingItem) {
      response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: existingItem.key, 
          quantity: existingItem.quantity + 1,
          sections: this.sections.join(',')
        })
      });
    } else {
      response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: this.sections.join(',')
        })
      });
    }

    if (!response.ok) {
      const errorData = await response.json();
      this.showErrorNotification(errorData.description || errorData.message || 'Не удалось добавить товар.');
      await this.updateCart();
      return;
    }

    const data = await response.json();

    if (data.sections) {
      this.sections.forEach(sectionId => {
        const target = document.getElementById(sectionId);
        if (target && data.sections[sectionId]) {
          target.innerHTML = this.getSectionInnerHTML(data.sections[sectionId], '.shopify-section');
        }
      });
    } else {
      await this.updateCart();
    }

    if (this.header && typeof this.header.reveal === 'function') this.header.reveal();
    
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mini-cart' });
    }

    this.open();

  } catch (e) {
    console.error(e);
    this.showErrorNotification('Произошла ошибка при добавлении товара.');
  } finally {
    button.innerHTML = originalContent;
    button.style.pointerEvents = '';
    button.style.opacity = '';
  }
}

  getItemKey(li) {
    return li.dataset.itemKey || li.dataset.variantId;
  }

  async handleQuantityChange(button) {
    const input = button.closest('.quantity').querySelector('.quantity__input');
    if (!input) return;
    
    const currentQuantity = parseInt(input.value, 10);
    let newQuantity = currentQuantity;

    if (button.name === 'plus') newQuantity++;
    if (button.name === 'minus') newQuantity--;
    if (newQuantity < 0) newQuantity = 0;

    if (newQuantity === currentQuantity) return;

    const li = button.closest('li');
    const itemKey = this.getItemKey(li);
    if (!itemKey) return;

    input.value = newQuantity;
    
    this.showLoader(li);
    await this.updateCartItem(itemKey, newQuantity, li);
  }

  async handleRemove(button) {
    const li = button.closest('li');
    const itemKey = this.getItemKey(li);
    if (!itemKey) return;

    this.showLoader(li);
    await this.updateCartItem(itemKey, 0, li);
  }

  async handleInputChange(input) {
    const newQuantity = parseInt(input.value, 10);
    const li = input.closest('li');
    const itemKey = this.getItemKey(li);
    
    if (!itemKey || isNaN(newQuantity)) return;

    this.showLoader(li);
    await this.updateCartItem(itemKey, newQuantity, li);
  }

  showLoader(li) {
    const loader = li.querySelector('.loading-overlay');
    if (loader) loader.classList.remove('hidden');
  }

  hideLoader(li) {
    const loader = li.querySelector('.loading-overlay');
    if (loader) loader.classList.add('hidden');
  }

  setControlsDisabled(disabled) {
    this.querySelectorAll('button, input, a.delete-product').forEach(el => {
      if (disabled) {
        el.setAttribute('disabled', 'disabled');
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
      } else {
        el.removeAttribute('disabled');
        el.style.pointerEvents = '';
        el.style.opacity = '';
      }
    });
  }

  async updateCartItem(id, quantity, li) {
    if (this.isUpdating) return;
    this.isUpdating = true;
    this.setControlsDisabled(true);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ 
          id: id, 
          quantity: quantity,
          sections: this.sections.join(',')
        })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        this.showErrorNotification(errorData.description || errorData.message || 'Недостаточно товара на складе.');
        await this.updateCart();
        return;
      }

      const data = await response.json();
      
      if (data.sections) {
        this.sections.forEach(sectionId => {
          const target = document.getElementById(sectionId);
          if (target && data.sections[sectionId]) {
            target.innerHTML = this.getSectionInnerHTML(data.sections[sectionId], '.shopify-section');
          }
        });
      } else {
        await this.updateCart();
      }
      
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mini-cart' });
      }
    } catch (e) {
      console.error(e);
      this.showErrorNotification('Произошла ошибка при обновлении корзины.');
      await this.updateCart();
    } finally {
      this.isUpdating = false;
      this.setControlsDisabled(false);
      if (li && document.body.contains(li)) {
        this.hideLoader(li);
      }
    }
  }

  showErrorNotification(message) {
    const existing = document.getElementById('mini-cart-error-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.id = 'mini-cart-error-toast';
    toast.textContent = message;
    
    Object.assign(toast.style, {
      position: 'fixed',
      top: '20px',
      right: '20px',
      background: '#e02424',
      color: '#ffffff',
      padding: '12px 20px',
      borderRadius: '4px',
      fontSize: '14px',
      zIndex: '9999',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      maxWidth: '300px',
      lineHeight: '1.4',
      opacity: '0',
      transition: 'opacity 0.3s ease'
    });

    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.style.opacity = '1';
    });

    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 5000);
  }

  async updateCart() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}?sections=${this.sections.join(',')}`);
      const data = await response.json();
      
      this.sections.forEach(sectionId => {
        const target = document.getElementById(sectionId);
        if (target && data[sectionId]) {
          target.innerHTML = this.getSectionInnerHTML(data[sectionId], '.shopify-section');
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  open() {
    if (!this.drawer) return;
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement && detailsElement.hasAttribute('open')) return;
    
    const summaryElement = this.drawer.querySelector('summary');
    if (summaryElement) summaryElement.click();

    setTimeout(() => {
      if (typeof setHeaderHeight === 'function') setHeaderHeight();
    }, 250);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    
    if (parsedState.sections) {
      this.sections.forEach(sectionId => {
        const target = document.getElementById(sectionId);
        if (target && parsedState.sections[sectionId]) {
          target.innerHTML = this.getSectionInnerHTML(parsedState.sections[sectionId], '.shopify-section');
        }
      });
    } else {
      this.updateCart();
    }

    if (this.header && typeof this.header.reveal === 'function') this.header.reveal();
    
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mini-cart' });
    }

    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const el = parsed.querySelector(selector);
    return el ? el.innerHTML : '';
  }
}

if (!customElements.get('mini-cart')) {
  customElements.define('mini-cart', MiniCart);
}